import {
  Show,
  SimpleShowLayout,
  TextField,
  Datagrid,
  useRecordContext,
} from "react-admin";
import React from "react";

const ImageGrid = () => {
  const record = useRecordContext();
  console.log(record);
  if (!record || !record.images) return null;

  return (
    <div className="photos_set">
      {record.images.map((url, index) => (
        <img key={index} src={url} alt="postpict" />
      ))}
    </div>
  );
};

const PostShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="postMessage" label="Post Message" />
      <TextField source="userName" label="User Name" />
      <ImageGrid />
      <TextField source="likes" label="Likes" />
      <Datagrid source="comments" label="Comments">
        <Datagrid bulkActionButtons={false}>
          <TextField source="id" label="User ID" />
          <TextField source="commentText" label="Comment" />
        </Datagrid>
      </Datagrid>
    </SimpleShowLayout>
  </Show>
);

export default PostShow;
